<template>
  <div class="flex items-center gap-1 justify-center lg:justify-end">
    <template v-if="useRoute().name?.includes('register')">
      <el-tooltip
        :content="`${$t('PublicCta.haveAccount')} ${$t('PublicCta.login')}`"
        placement="left"
        :disabled="$i18n.locale !== 'ua'"
      >
        <span>
          <span>{{ $t('PublicCta.haveAccount') }}&nbsp;</span>
          <nuxt-link :to="localePath('/login')">
            {{ $t('PublicCta.login') }}
          </nuxt-link>
        </span>
      </el-tooltip>
    </template>
    <template v-else>
      <el-tooltip
        :content="`${$t('PublicCta.doNotHaveAccount')} ${$t('PublicCta.register')}`"
        placement="left"
        :disabled="$i18n.locale !== 'ua'"
      >
        <span>
          <span>{{ $t('PublicCta.doNotHaveAccount') }}&nbsp;</span>
          <nuxt-link :to="localePath('/register')">
            {{ $t('PublicCta.register') }}
          </nuxt-link>
        </span>
      </el-tooltip>
    </template>
  </div>
</template>

<script setup>
const localePath = useLocalePath();
</script>
